import * as React from 'react';

import * as styles from './FilterAreaWrapper.css';

interface IFilterAreaWrapperProps {
  totalArea: React.ReactNode;
  kitchenArea: React.ReactNode;
  livingArea: React.ReactNode;
}

export const FilterAreaWrapper: React.FC<IFilterAreaWrapperProps> = ({ totalArea, kitchenArea, livingArea }) => {
  return (
    <div className={styles['container']}>
      <div data-testid="TotalAreaContainer">{totalArea}</div>
      <div>{kitchenArea}</div>
      <div>{livingArea}</div>
    </div>
  );
};
